<template>
  <div>
    <Carousel
      :autoplay="true"
      :per-page="3"
      :loop="true"
      :navigation-enabled="false"
      :pagination-enabled="false"
      :scroll-per-page="false"
    >
      <Slide v-for="(logo, k) in logos" v-cloak :key="k">
        <img :src="logo" class="opacity-5" />
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'ClientsLogo',

  components: {
    Carousel,
    Slide
  },

  props: {
    logos: { required: true, type: Array }
  }
};
</script>
